class ShippingProgressBar extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    
    // Default properties
    this._threshold = 7500; // $75.00 in cents
    this._current = 0;
    this._currency = '$';
    this._thresholdMessage = 'Add __AMOUNT__ more to get FREE shipping!';
    this._successMessage = 'Congratulations! You qualify for FREE shipping!';
    this._progressColor = '#4CAF50';
    this._backgroundColor = '#f0f0f0';
  }

  static get observedAttributes() {
    return [
      'threshold', 
      'current', 
      'currency', 
      'threshold-message', 
      'success-message',
      'progress-color',
      'background-color'
    ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    
    switch(name) {
      case 'threshold':
        this._threshold = parseInt(newValue, 10);
        break;
      case 'current':
        this._current = parseInt(newValue, 10);
        break;
      case 'currency':
        this._currency = newValue;
        break;
      case 'threshold-message':
        this._thresholdMessage = newValue;
        break;
      case 'success-message':
        this._successMessage = newValue;
        break;
      case 'progress-color':
        this._progressColor = newValue;
        break;
      case 'background-color':
        this._backgroundColor = newValue;
        break;
    }
    
    this.render();
  }

  connectedCallback() {
    // Get attributes on initial render
    if (this.hasAttribute('threshold')) {
      this._threshold = parseInt(this.getAttribute('threshold'), 10);
    }
    
    if (this.hasAttribute('current')) {
      this._current = parseInt(this.getAttribute('current'), 10);
    }
    
    if (this.hasAttribute('currency')) {
      this._currency = this.getAttribute('currency');
    }
    
    if (this.hasAttribute('threshold-message')) {
      this._thresholdMessage = this.getAttribute('threshold-message');
    }
    
    if (this.hasAttribute('success-message')) {
      this._successMessage = this.getAttribute('success-message');
    }
    
    if (this.hasAttribute('progress-color')) {
      this._progressColor = this.getAttribute('progress-color');
    }
    
    if (this.hasAttribute('background-color')) {
      this._backgroundColor = this.getAttribute('background-color');
    }
    
    this.render();
  }

  formatCurrency(cents) {
    return (cents / 100).toFixed(2)+this._currency;
  }

  render() {
    // Calculate progress bar values
    const progressPercentage = Math.min(100, (this._current / this._threshold) * 100);
    const remainingAmount = Math.max(0, this._threshold - this._current);
    const formattedAmount = this.formatCurrency(remainingAmount);

    // Create HTML content
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          width: 100%;
        }
        
        .progress-container {
          margin: 0;
          padding: 15px;
          border-radius: 8px;
          background-color: white;
        }
        
        .progress-message {
          margin-bottom: 5px;
          text-align: center;
          font-size: 15px;
          line-height: 1.4;
        }
        
        
        .progress-bar {
          height: 10px;
          background-color: ${this._backgroundColor};
          border-radius: 5px;
          overflow: hidden;
          position: relative;
        }
        
        .progress-fill {
          height: 100%;
          width: ${progressPercentage}%;
          background-color: ${this._progressColor};
          border-radius: 5px;
          transition: width 0.4s ease-in-out;
        }
      </style>
      
      <div class="progress-container">
        <div class="progress-message">
          ${remainingAmount > 0 
            ? this._thresholdMessage.replace('__AMOUNT__', `<span class="progress-remaining">${formattedAmount}</span>`)
            : `<span class="progress-complete">${this._successMessage}</span>`
          }
        </div>
        <div class="progress-bar">
          <div class="progress-fill"></div>
        </div>
      </div>
    `;
  }
}

// Register the custom element
customElements.define('shipping-progress-bar', ShippingProgressBar);
class CollectionHeaderTimer extends HTMLElement {
  constructor() {
    super();
    this.endTime = new Date(this.getAttribute("end-date")).getTime();
    //this.shadow = this.attachShadow({ mode: "open" });
  }

  updateCountdown() {
    const now = new Date().getTime();
    const timeRemaining = this.endTime - now;

    if (timeRemaining <= 0) {
      // Countdown has ended, hide the element
      this.style.display = "none";
      document.querySelector(".countdown-wrapper").style.display="none";
    } else {
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      /*this.innerHTML = `
        <div class="timer-item days-item"><span>${String(days).padStart(2, '0')}</span><span class="small-size">days</span></div>
        <div class="timer-item hours-item"><span>${String(hours).padStart(2, '0')}</span><span class="small-size">hours</span></div>
        <div class="timer-item minutes-item"><span>${String(minutes).padStart(2, '0')}</span><span class="small-size">minutes</span></div>
        <div class="timer-item seconds-items"><span>${String(seconds).padStart(2, '0')}</span><span class="small-size">seconds</span></div>
      `;*/
      this.querySelector(".days-counter").innerHTML = String(days).padStart(2, '0');
      this.querySelector(".hours-counter").innerHTML = String(hours).padStart(2, '0');
      this.querySelector(".minutes-counter").innerHTML = String(minutes).padStart(2, '0');
      this.querySelector(".seconds-counter").innerHTML = String(seconds).padStart(2, '0');
    }
  }
  addHTML(){
     this.innerHTML = `
        <div class="timer-item days-item"><span class="days-counter">${String(0).padStart(2, '0')}</span><span class="small-size">JOURS</span></div>
        <div class="timer-item hours-item"><span class="hours-counter">${String(0).padStart(2, '0')}</span><span class="small-size">HEURES</span></div>
        <div class="timer-item minutes-item"><span class="minutes-counter">${String(0).padStart(2, '0')}</span><span class="small-size">MINUTES</span></div>
        <div class="timer-item seconds-items"><span class="seconds-counter">${String(0).padStart(2, '0')}</span><span class="small-size">SECONDES</span></div>`;
    
  }
  connectedCallback() {
    this.addHTML();
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define("collection-header-timer", CollectionHeaderTimer);
const updateAB001Products = () => {
  if(document.querySelectorAll(".navigation__link.custom-pack-starter").length > 0){
    document.querySelectorAll(".navigation__link.custom-pack-starter").forEach((el) => {
      if(document.body.classList.contains("hw-abt-1-1") || window.ABTEST.abt1 == 'v1' ){
        el.href="/products/pack-starter-1"
      }else if(document.body.classList.contains("hw-abt-1-2") || window.ABTEST.abt1 == 'v2' ){
        el.href="/products/pack-starter-2"
      }else if(document.body.classList.contains("hw-abt-1-3") || window.ABTEST.abt1 == 'v3' ){
        el.href="/products/pack-starter-3"
      }
    });
  }
  
  const wpn = window.location.pathname; //console.log(wpn);
  const wpu = wpn.split("/");
  const pg = wpu.pop(); //console.log(pg);
     
  if(document.body.classList.contains("hw-abt-1-0")){
    if(pg == 'packstarter') { window.location = '/products/pack-starter-0'; }
    if(pg == 'pack-starter-1') { window.location = '/products/pack-starter-0'; }
    if(pg == 'pack-starter-2') { window.location = '/products/pack-starter-0'; }
    if(pg == 'pack-starter-3') { window.location = '/products/pack-starter-0'; }
  }else if(document.body.classList.contains("hw-abt-1-1")){
    if(pg == 'packstarter') { window.location = '/products/pack-starter-1'; }
    if(pg == 'pack-starter-0') { window.location = '/products/pack-starter-1'; }
    if(pg == 'pack-starter-2') { window.location = '/products/pack-starter-1'; }
    if(pg == 'pack-starter-3') { window.location = '/products/pack-starter-1'; }
  }else if(document.body.classList.contains("hw-abt-1-2")){
     if(pg == 'packstarter') { window.location = '/products/pack-starter-2'; }
    if(pg == 'pack-starter-0') { window.location = '/products/pack-starter-2'; }
    if(pg == 'pack-starter-1') { window.location = '/products/pack-starter-2'; }
    if(pg == 'pack-starter-3') { window.location = '/products/pack-starter-2'; }
  }else if(document.body.classList.contains("hw-abt-1-3")){
     if(pg == 'packstarter') { window.location = '/products/pack-starter-3'; }
    if(pg == 'pack-starter-0') { window.location = '/products/pack-starter-3'; }
    if(pg == 'pack-starter-1') { window.location = '/products/pack-starter-3'; }
    if(pg == 'pack-starter-2') { window.location = '/products/pack-starter-3'; }
  }
}
const updateAB002Products = () => {
  const wpn = window.location.pathname; //console.log(wpn);
  const wpu = wpn.split("/");
  const pg = wpu.pop(); //console.log(pg);
     
  if(document.body.classList.contains("hw-abt-2-0")){
    document.querySelector(".custom-check-buttons-wrapper")?.classList.add("hide");
    if(pg == 'rez-1') { window.location = '/products/rez'; }
    if(pg == 'rez-2') { window.location = '/products/rez'; }
    if(pg == 'rez-3') { window.location = '/products/rez'; }
    if(pg == 'rez-4') { window.location = '/products/rez'; }
  }else if(document.body.classList.contains("hw-abt-2-1")){
    document.querySelector(".custom-check-buttons-wrapper")?.classList.remove("hide");
    if(pg == 'rez') { window.location = '/products/rez-1'; }
    if(pg == 'rez-2') { window.location = '/products/rez-1'; }
    if(pg == 'rez-3') { window.location = '/products/rez-1'; }
    if(pg == 'rez-4') { window.location = '/products/rez-1'; }
  }else if(document.body.classList.contains("hw-abt-2-2")){
     document.querySelector(".custom-check-buttons-wrapper")?.classList.remove("hide");
    if(pg == 'rez') { window.location = '/products/rez-2'; }
    if(pg == 'rez-1') { window.location = '/products/rez-2'; }
    if(pg == 'rez-3') { window.location = '/products/rez-2'; }
    if(pg == 'rez-4') { window.location = '/products/rez-2'; }
  }else if(document.body.classList.contains("hw-abt-2-3")){
     document.querySelector(".custom-check-buttons-wrapper")?.classList.remove("hide");
    if(pg == 'rez') { window.location = '/products/rez-3'; }
    if(pg == 'rez-1') { window.location = '/products/rez-3'; }
    if(pg == 'rez-2') { window.location = '/products/rez-3'; }
    if(pg == 'rez-4') { window.location = '/products/rez-3'; }
  }else if(document.body.classList.contains("hw-abt-2-4")){
     document.querySelector(".custom-check-buttons-wrapper")?.classList.remove("hide");
    if(pg == 'rez') { window.location = '/products/rez-4'; }
    if(pg == 'rez-1') { window.location = '/products/rez-4'; }
    if(pg == 'rez-2') { window.location = '/products/rez-4'; }
    if(pg == 'rez-3') { window.location = '/products/rez-4'; }
  }
}
const updateAB3Content = () => {

  if(document.querySelectorAll(".navigation__link.custom-devenir-membre").length > 0){
    document.querySelectorAll(".navigation__link.custom-devenir-membre").forEach((el) => {
      if(document.body.classList.contains("hw-abt-3-1") || window.ABTEST.abt3 == 'v1' ){
        el.href="/products/membre-1"
      }else if(document.body.classList.contains("hw-abt-3-2") || window.ABTEST.abt3 == 'v2' ){
        el.href="/products/membre-2"
      }else if(document.body.classList.contains("hw-abt-3-3") || window.ABTEST.abt3 == 'v3' ){
        el.href="/products/membre-3"
      }else if(document.body.classList.contains("hw-abt-3-4") || window.ABTEST.abt3 == 'v4' ){
        el.href="/products/membre-4"
      }
    });
  }
  const wpn = window.location.pathname; //console.log(wpn);
  const wpu = wpn.split("/");
  const pg = wpu.pop(); //console.log(pg);
    if(document.body.classList.contains("hw-abt-3-1") && pg == 'membre-0') { 
      window.location = '/products/membre-1'; 
    }else if(document.body.classList.contains("hw-abt-3-1") && pg == 'membre-2') { 
      window.location = '/products/membre-1'; 
    }else if(document.body.classList.contains("hw-abt-3-1") && pg == 'membre-3') { 
      window.location = '/products/membre-1'; 
    }else if(document.body.classList.contains("hw-abt-3-1") && pg == 'membre-4') { 
      window.location = '/products/membre-1'; 
    }
  
    if(document.body.classList.contains("hw-abt-3-2") && pg == 'membre-0') { 
      window.location = '/products/membre-2'; 
    }else if(document.body.classList.contains("hw-abt-3-2") && pg == 'membre-1') { 
      window.location = '/products/membre-2'; 
    }else if(document.body.classList.contains("hw-abt-3-2") && pg == 'membre-3') { 
      window.location = '/products/membre-2'; 
    }else if(document.body.classList.contains("hw-abt-3-2") && pg == 'membre-4') { 
      window.location = '/products/membre-2'; 
    }

    if(document.body.classList.contains("hw-abt-3-3") && pg == 'membre-0') { 
      window.location = '/products/membre-3'; 
    }else if(document.body.classList.contains("hw-abt-3-3") && pg == 'membre-1') { 
      window.location = '/products/membre-3'; 
    }else if(document.body.classList.contains("hw-abt-3-3") && pg == 'membre-2') { 
      window.location = '/products/membre-2'; 
    }else if(document.body.classList.contains("hw-abt-3-3") && pg == 'membre-4') { 
      window.location = '/products/membre-2'; 
    }

    if(document.body.classList.contains("hw-abt-3-4") && pg == 'membre-0') { 
      window.location = '/products/membre-4'; 
    }else if(document.body.classList.contains("hw-abt-3-4") && pg == 'membre-1') { 
      window.location = '/products/membre-4'; 
    }else if(document.body.classList.contains("hw-abt-3-4") && pg == 'membre-2') { 
      window.location = '/products/membre-4'; 
    }else if(document.body.classList.contains("hw-abt-3-4") && pg == 'membre-3') { 
      window.location = '/products/membre-4'; 
    }
  
    if(document.body.classList.contains("hw-abt-3-0") && pg == 'membre-1') { 
      window.location = '/products/membre-0'; 
    }else if(document.body.classList.contains("hw-abt-3-0") && pg == 'membre-2') { 
      window.location = '/products/membre-0'; 
    }else if(document.body.classList.contains("hw-abt-3-0") && pg == 'membre-3') { 
      window.location = '/products/membre-0'; 
    }else if(document.body.classList.contains("hw-abt-3-0") && pg == 'membre-4') { 
      window.location = '/products/membre-0'; 
    }
}
const initializeBodyObservation = () => {
  const targetNode = document.body;
  const config = { attributes: true };
  const callback = function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      console.log("ddddd");
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if(window.ABTEST.abt1 == 'test' && window.ABTEST.design_mode == false  && (targetNode.classList.contains("hw-abt-1-0") || targetNode.classList.contains("hw-abt-1-1") || targetNode.classList.contains("hw-abt-1-2") || targetNode.classList.contains("hw-abt-1-3"))){
          updateAB001Products();
        }
        if (targetNode.classList.contains("hw-abt-3-0") || targetNode.classList.contains("hw-abt-3-1") || targetNode.classList.contains("hw-abt-3-2") || targetNode.classList.contains("hw-abt-3-3") || targetNode.classList.contains("hw-abt-3-4")) {
          if(window.ABTEST.abt3 == 'test' && window.ABTEST.design_mode == false ){
              updateAB3Content();
          }
        }
       if(window.ABTEST.abt2 == 'test' && window.ABTEST.design_mode == false  && (targetNode.classList.contains("hw-abt-2-0") || targetNode.classList.contains("hw-abt-2-1") || targetNode.classList.contains("hw-abt-2-2") || targetNode.classList.contains("hw-abt-2-3") || targetNode.classList.contains("hw-abt-2-4"))){
          updateAB002Products();
        }
        
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}
document.addEventListener('DOMContentLoaded', (event) => {
   const scrollElements = document.querySelectorAll('.bundle-product-list');
  if(scrollElements.length > 0){
     // Initialize SimpleBar on each element
    scrollElements.forEach(function(element) {
      new SimpleBar(element, { 
        autoHide: false,
        forceVisible: 'y', // Force vertical scrollbar to always be visible
        clickOnTrack: true
      });
    });
    
    // Optional: Function to update all scrollbars if content changes dynamically
    window.updateAllScrollbars = function() {
      scrollElements.forEach(function(element) {
        const simpleBarInstance = SimpleBar.instances.get(element);
        if (simpleBarInstance) {
          simpleBarInstance.recalculate();
        }
      });
    };
  }
 
  
  //initializeBodyObservation();
});
jQuery(document).ready(function($) {
  
   $(document).on("change",".cart-upsell__actions select",function(){
    var variantID = $(this).val();
    if($(".cart-upsell__image").length > 0){
      $(`.cart-upsell__image`).hide();
      $(`.cart-upsell__image[data-variant-id="${variantID}"]`).show();
    }
  });
  $(document).on("change",".custom-pack-variant-selector",function(){
    var variantID = $(this).val();
    if($(".custom-vairant-images img").length > 0){
      var image = $(`.custom-vairant-images img[data-variantid="${variantID}"]`);
      var parentELement = $(this).parents(".product-block");
      
      if(image){
        console.log(parentELement.find(".rimage__image"), image.attr("src"));
        parentELement.find(".rimage__image").attr("srcset", image.attr("src"));
      }
    }
  });
  $(document).on("click", ".custom-filter-box ", function () {
    $(".custom-filter-box").removeClass("active"),
      $(this).addClass("active");
    const t2 = $(this).data("id"),
      e2 = $(this).hasClass("first-class");
    $(".filter-items").each(function () {
      e2
        ? $(".filter-items").removeClass("hide").slideDown()
        : $(this).attr("id") != t2
        ? (($that = $(this)),
          $(this).slideUp(function () {
            $that.addClass("hide");
          }))
        : ($(this).removeClass("hide"), $(this).slideDown());
    });
  });
  $(document).on("click", ".custom-quick-add__submit", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(".custom-modal__centered.active").removeClass("active");
      const pid = $(this).data("id");
      $(`.custom-modal__centered[data-id="${pid}"]`).addClass("active"),
      $("body").addClass("remove-zindex");
   
  });
  $(document).on("click", "button.custom-modal__close", function () {
    $(".custom-modal__centered.active").removeClass("active"),
      $("body").removeClass("remove-zindex");
  });
  $(window).on('cc-variant-updated', function(event, data) {
    // The data parameter contains the information passed by trigger()
    var variant = data.variant;
    var product = data.product;
    if( $(".custom-pack-image-wraper.is-changable").length > 0){
       $(".custom-pack-image-wraper.is-changable").addClass("hide");
      $(`.custom-pack-image-wraper.is-changable[data-vid="${variant.option1}"]`).removeClass("hide");
    }
    
    if($(".custom-ragular-price").length > 0 && variant){
      $(".custom-ragular-price").text(theme.Shopify.formatMoney(variant.price,theme.money_format));
      if(variant.compare_at_price > variant.price){
        $(".custom-ragular-c-price").text(theme.Shopify.formatMoney(variant.compare_at_price,theme.money_format));
      }else{
         $(".custom-ragular-c-price").text("");
      }
    }
    var slideIndex = $('[data-media-id="' + variant.id + '"]').data('slick-index');
        $('.gallery-main-image').slick('slickGoTo', slideIndex);
    // Your code to handle the variant change goes here
    // For example, update pricing, images, availability, etc.
  });
  
 
});
jQuery(window).on("load",function(){
  setTimeout(function(){
    if($(`.template-suffix-packs .input-row.-variant-picker .custom-packs-items-wrapper input[value="Pack 2"]`).length > 0){
       $(`.template-suffix-packs .input-row.-variant-picker .custom-packs-items-wrapper input[value="Pack 2"]`).first().prop("checked",true).trigger("change");
      setTimeout(() => {
         $(`.template-suffix-packs .input-row.-variant-picker .custom-packs-items-wrapper input[value="Pack 2"]`).first().prop("checked",true).trigger("change");
      },1000);
    }
    if($("body.custom-product-hide-price").length > 0){
      $("body.custom-product-hide-price").removeClass('custom-product-hide-price');
    }
    /*if($(".custom-product-hide-price .promo-container").length > 0){
      $(".custom-product-hide-price .promo-container").css('opacity',1);
    }
    if($(".custom-product-hide-price .price-area").length > 0){
      $(".custom-product-hide-price .price-area").css('opacity',1);
    }*/
  },1000);
});

// Cart Drawer Countdown Timer
document.addEventListener('DOMContentLoaded', function() {
  // Select the countdown wrapper element
  const countdownWrapper = document.querySelector('.custom-countdown-wrapper');
  
  // If countdown element doesn't exist, exit early
  if (!countdownWrapper) return;
  
  // Get total minutes from data-time attribute and convert to seconds
  const totalMinutes = parseInt(countdownWrapper.getAttribute('data-time') || 10, 10);
  const TOTAL_TIME = totalMinutes * 60; // Convert minutes to seconds
  
  // Select the countdown display element
  const timerDisplay = countdownWrapper.querySelector('.custom-countdown-main');
  
  // If timer display doesn't exist, exit early
  if (!timerDisplay) return;
  
  // Timer state variables
  let timeRemaining;
  let timerInterval;
  let timerActive = false;
  
  // Function to check if cart has items
  async function checkCartHasItems() {
    try {
      // Fetch cart data from Shopify
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart.item_count > 0;
    } catch (error) {
      console.error('Error checking cart:', error);
      return false;
    }
  }
  
  // Initialize timer
  initializeTimer();
  
  // Functions
  async function initializeTimer() {
    // Check if cart has items first
    const hasItems = await checkCartHasItems();
    
    if (!hasItems) {
      // Hide countdown if cart is empty
      countdownWrapper.style.display = 'none';
      clearCartTimerStorage();
      return;
    }
    
    // Check if there's a stored timer value in sessionStorage
    const storedTimeStamp = sessionStorage.getItem('cartTimerExpiry');
    const storedTimeRemaining = sessionStorage.getItem('cartTimeRemaining');
    
    if (storedTimeStamp && storedTimeRemaining) {
      const now = Date.now();
      const expiry = parseInt(storedTimeStamp, 10);
      
      // Calculate how much time has passed since the timer was paused
      if (now < expiry) {
        // Timer was still running, calculate remaining time
        timeRemaining = Math.round((expiry - now) / 1000);
      } else {
        // Timer expired since last visit
        timeRemaining = 0;
      }
    } else {
      // First time initialization
      timeRemaining = TOTAL_TIME;
    }
    
    // If timer is at 0, reset it to full time
    if (timeRemaining <= 0) {
      timeRemaining = TOTAL_TIME;
    }
    
    // Make countdown visible
    countdownWrapper.style.display = '';
    
    // Update display and start timer
    updateTimerDisplay();
    startTimer();
  }
  
  function startTimer() {
    if (!timerActive) {
      timerActive = true;
      
      // Store the expected end time
      const expiryTime = Date.now() + (timeRemaining * 1000);
      sessionStorage.setItem('cartTimerExpiry', expiryTime);
      
      timerInterval = setInterval(function() {
        timeRemaining--;
        updateTimerDisplay();
        
        // Update sessionStorage every second
        sessionStorage.setItem('cartTimeRemaining', timeRemaining);
        sessionStorage.setItem('cartTimerExpiry', Date.now() + (timeRemaining * 1000));
        
        if (timeRemaining <= 0) {
          // Timer completed
          handleTimerComplete();
        }
      }, 1000);
    }
  }
  
  function stopTimer() {
    // Clear interval
    clearInterval(timerInterval);
    timerActive = false;
    
    // Hide the countdown wrapper
    countdownWrapper.style.display = 'none';
    
    // Clear the sessionStorage
    clearCartTimerStorage();
  }
  
  function updateTimerDisplay() {
    const minutes = Math.floor(timeRemaining / 60);
    const seconds = timeRemaining % 60;
    
    // Format time as MM:SS
    timerDisplay.textContent = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
  
  function handleTimerComplete() {
    // Clear interval
    clearInterval(timerInterval);
    timerActive = false;
    
    // Hide the countdown wrapper
    countdownWrapper.style.display = 'none';
    
    // Clear the sessionStorage for cart timer
    clearCartTimerStorage();
  }
  
  function clearCartTimerStorage() {
    // Remove all cart timer related items from sessionStorage
    sessionStorage.removeItem('cartTimeRemaining');
    sessionStorage.removeItem('cartTimerExpiry');
  }
  
  // Shopify specific - listen for cart updates
  document.addEventListener('cart_drawer:updated', async function(event) {
    if (event.detail && event.detail.cart) {
      if (event.detail.cart.item_count === 0) {
        // Cart is empty, stop timer
        stopTimer();
      } else if (!timerActive) {
        // Cart has items and timer is not active, start timer
        timeRemaining = TOTAL_TIME; // Reset to full time
        countdownWrapper.style.display = '';
        updateTimerDisplay();
        startTimer();
      }
    } else {
      // If event.detail.cart is not available, check cart manually
      const hasItems = await checkCartHasItems();
      if (!hasItems) {
        stopTimer();
      } else if (!timerActive) {
        timeRemaining = TOTAL_TIME;
        countdownWrapper.style.display = '';
        updateTimerDisplay();
        startTimer();
      }
    }
  });
  
  // Alternative approach for Shopify - monitor Ajax requests
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    const promise = originalFetch.apply(this, arguments);
    
    // Check if this is a cart update
    if (url && typeof url === 'string') {
      if (url.includes('/cart/clear.js') || url.includes('/cart/clear')) {
        // Cart clear request
        promise.then(() => {
          stopTimer();
        });
      } else if (url.includes('/cart/add.js') || url.includes('/cart/add') || 
                url.includes('/cart/update.js') || url.includes('/cart/update') ||
                url.includes('/cart/change.js') || url.includes('/cart/change')) {
        // Cart addition/update request
        promise.then(async (response) => {
          const hasItems = await checkCartHasItems();
          if (hasItems && !timerActive) {
            timeRemaining = TOTAL_TIME;
            countdownWrapper.style.display = '';
            updateTimerDisplay();
            startTimer();
          }
        });
      }
    }
    
    return promise;
  };
  
  // No visibility change handling - countdown continues running in background
  
  // Function to handle window unload (close/refresh)
  window.addEventListener('beforeunload', function() {
    if (timerActive) {
      sessionStorage.setItem('cartTimeRemaining', timeRemaining);
      sessionStorage.setItem('cartTimerExpiry', Date.now() + (timeRemaining * 1000));
    }
  });
});

$(document).ready(function() {
  if($(".sticky-select .option-selectors").length <= 0 && $(".sticky-atc").length > 0){
    $(".sticky-atc").css("width","100%");
  }
  // Add click handler for all toggle headers
  $(document).on("click",".toggle-header", function() {
      // Toggle visibility of the associated grocery items
      $(this).next(".grocery-items").toggle();
     $(this).find(".dropdown-icon").toggleClass("open");

    let headerTextElement = $(this).find(".header-text");
    let currentText = headerTextElement.text();
    
    if (currentText.includes("Afficher")) {
        headerTextElement.text(currentText.replace("Afficher", "Masquer"));
    } else {
        headerTextElement.text(currentText.replace("Masquer", "Afficher"));
    }
  });
});

$(document).on('variantChanged', function(e, variant, product) {
      // If product doesn't have variants, don't do anything
      if (!window.customProductVariants) {
        return;
      }
      
      setTimeout(function() {
        if(window.customProductVariants && window.customProductVariants.length > 0){
            const findMatchedVariant = window.customProductVariants.find((v) => v.id === variant.id);
            
            // Use the found variant
            if (findMatchedVariant) {
              // Do something with the matched variant
              console.log('Matching variant found:', findMatchedVariant,findMatchedVariant.subscription_required == true);
              if(findMatchedVariant.subscription_required == true){
                $(`.btn_radio[data-target="subscribe-text"]`).click();
              }else{
                $(`.btn_radio[data-target="no-subscribe-text"]`).click();
              }
            }
        }
      }, 100);
});